import { render, staticRenderFns } from "./pInviteInfo.vue?vue&type=template&id=501b7a9a&scoped=true&"
import script from "./pInviteInfo.vue?vue&type=script&lang=js&"
export * from "./pInviteInfo.vue?vue&type=script&lang=js&"
import style0 from "./pInviteInfo.vue?vue&type=style&index=0&id=501b7a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b7a9a",
  null
  
)

export default component.exports